import { mutator } from 'satcheljs';
import setCurrentBccRecipient from '../actions/setCurrentBccRecipient';

// Sets the currentBccRecipient in SmimeViewState
export default mutator(setCurrentBccRecipient, actionMessage => {
    const { smimeViewState, currentBccRecipient } = actionMessage;
    smimeViewState.currentBccRecipientIndex = currentBccRecipient;
});
